import AgentLayout from './AgentLayout';
import VerificationPanelDetail from './verification/VerificationPanelDetail';

function AgentVerificationDetail() {
  return (
    <AgentLayout>
      <VerificationPanelDetail
        apiPrefix="/agent/verification"
        listPathPrefix="/agent/verification"
      />
    </AgentLayout>
  );
}

export default AgentVerificationDetail;